import toast from "react-hot-toast";
import * as api from "../Api";

export const getLocationStock = () => async (dispatch) => {
  try {
    const { data } = await api.getLocationStock();
    dispatch({ type: "LOCATION_STOCK", payload: data });
  } catch (error) {}
};

export const createLocationStock = (postData) => async (dispatch) => {
  let creatingId;
  try {
    creatingId = toast.loading("replenishing your stock...");
    const { data } = await api.locationCreateStock(postData);
    dispatch({ type: "LOCATION_CREATE_STOCK", payload: data });
    toast.remove(creatingId);
    toast.success("stock successfully replenished");
    return data;
  } catch (error) {
    toast.remove(creatingId);
    toast.error(error.response?.data?.message || "Something went wrong");
    throw error;
  }
};
